var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _setup.onSubmitHandler.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "pm-summary-form",
          class: { "pm-summary-form--wide": _vm.wide }
        },
        [
          _c(
            "div",
            { staticClass: "fields-col" },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("General Info")
              ]),
              _c("v-autocomplete", {
                attrs: {
                  outlined: "",
                  dense: "",
                  "hide-details": "auto",
                  label: "Customer *",
                  items: _setup.customerState.items,
                  "item-value": "id",
                  "item-text": "company",
                  loading: _setup.customerState.isLoading,
                  "error-messages": _setup.formState.errors.customer_id
                },
                model: {
                  value: _setup.formState.data.customer_id,
                  callback: function($$v) {
                    _vm.$set(_setup.formState.data, "customer_id", $$v)
                  },
                  expression: "formState.data.customer_id"
                }
              }),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  "hide-details": "auto",
                  label: "PM Month *",
                  type: "month",
                  "error-messages": _setup.formState.errors.pm_month
                },
                model: {
                  value: _setup.formState.data.pm_month,
                  callback: function($$v) {
                    _vm.$set(_setup.formState.data, "pm_month", $$v)
                  },
                  expression: "formState.data.pm_month"
                }
              }),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  "hide-details": "auto",
                  label: "Attention Name",
                  "error-messages": _setup.formState.errors.attention_name
                },
                model: {
                  value: _setup.formState.data.attention_name,
                  callback: function($$v) {
                    _vm.$set(_setup.formState.data, "attention_name", $$v)
                  },
                  expression: "formState.data.attention_name"
                }
              }),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  "hide-details": "auto",
                  label: "Subject",
                  "error-messages": _setup.formState.errors.subject
                },
                model: {
                  value: _setup.formState.data.subject,
                  callback: function($$v) {
                    _vm.$set(_setup.formState.data, "subject", $$v)
                  },
                  expression: "formState.data.subject"
                }
              }),
              _c("v-textarea", {
                attrs: {
                  outlined: "",
                  dense: "",
                  "hide-details": "auto",
                  label: "PM Activities",
                  "error-messages": _setup.formState.errors.pm_activities,
                  rows: 3
                },
                model: {
                  value: _setup.formState.data.pm_activities,
                  callback: function($$v) {
                    _vm.$set(_setup.formState.data, "pm_activities", $$v)
                  },
                  expression: "formState.data.pm_activities"
                }
              }),
              _c("v-textarea", {
                attrs: {
                  outlined: "",
                  dense: "",
                  "hide-details": "auto",
                  label: "Notes",
                  "error-messages": _setup.formState.errors.notes,
                  rows: 3
                },
                model: {
                  value: _setup.formState.data.notes,
                  callback: function($$v) {
                    _vm.$set(_setup.formState.data, "notes", $$v)
                  },
                  expression: "formState.data.notes"
                }
              }),
              _c("div", { staticClass: "section-title" }, [
                _vm._v("Signatories")
              ]),
              _c(
                "div",
                { staticClass: "two-col" },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "auto",
                      label: "Prepared By (Name)",
                      "error-messages": _setup.formState.errors.prepared_by_name
                    },
                    model: {
                      value: _setup.formState.data.prepared_by_name,
                      callback: function($$v) {
                        _vm.$set(_setup.formState.data, "prepared_by_name", $$v)
                      },
                      expression: "formState.data.prepared_by_name"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "auto",
                      label: "Prepared By (Title)",
                      "error-messages":
                        _setup.formState.errors.prepared_by_title
                    },
                    model: {
                      value: _setup.formState.data.prepared_by_title,
                      callback: function($$v) {
                        _vm.$set(
                          _setup.formState.data,
                          "prepared_by_title",
                          $$v
                        )
                      },
                      expression: "formState.data.prepared_by_title"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "auto",
                      label: "Approved By (Name)",
                      "error-messages": _setup.formState.errors.approved_by_name
                    },
                    model: {
                      value: _setup.formState.data.approved_by_name,
                      callback: function($$v) {
                        _vm.$set(_setup.formState.data, "approved_by_name", $$v)
                      },
                      expression: "formState.data.approved_by_name"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "auto",
                      label: "Approved By (Title)",
                      "error-messages":
                        _setup.formState.errors.approved_by_title
                    },
                    model: {
                      value: _setup.formState.data.approved_by_title,
                      callback: function($$v) {
                        _vm.$set(
                          _setup.formState.data,
                          "approved_by_title",
                          $$v
                        )
                      },
                      expression: "formState.data.approved_by_title"
                    }
                  })
                ],
                1
              ),
              _setup.props.editId
                ? _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "warning",
                            type: "submit",
                            loading: _setup.formState.isLoading,
                            disabled: _setup.formState.isLoading
                          }
                        },
                        [_vm._v(" Update ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error", type: "button" },
                          on: { click: _setup.onCancelHandler }
                        },
                        [_vm._v(" Cancel ")]
                      )
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        dark: "",
                        type: "submit",
                        loading: _setup.formState.isLoading,
                        disabled: _setup.formState.isLoading
                      }
                    },
                    [_vm._v(" Submit ")]
                  )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "units-col" },
            [
              _c(
                "div",
                { staticClass: "units-header" },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("Units")
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        outlined: "",
                        color: "primary",
                        type: "button"
                      },
                      on: { click: _setup.addUnit }
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-plus")
                      ]),
                      _vm._v(" Add Unit ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "generate-units-row" },
                [
                  _c("v-combobox", {
                    attrs: {
                      dense: "",
                      outlined: "",
                      "hide-details": "",
                      label: "Client(s) (for generating units)",
                      items: _setup.clientList.items,
                      loading: _setup.clientList.isLoading,
                      multiple: "",
                      chips: "",
                      "small-chips": "",
                      "deletable-chips": "",
                      clearable: ""
                    },
                    model: {
                      value: _setup.generateClients,
                      callback: function($$v) {
                        _setup.generateClients = $$v
                      },
                      expression: "generateClients"
                    }
                  }),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        outlined: "",
                        color: "teal",
                        type: "button",
                        disabled: !_setup.canGenerateUnits,
                        loading: _setup.suggestState.isLoading
                      },
                      on: { click: _setup.generateUnits }
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-auto-fix")
                      ]),
                      _vm._v(" Generate ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.wide
                ? [
                    _c("div", { staticClass: "units-table-wrap" }, [
                      _c("table", { staticClass: "units-table" }, [
                        _vm._m(0),
                        _c(
                          "tbody",
                          _vm._l(_setup.formState.data.units, function(
                            unit,
                            index
                          ) {
                            return _c("tr", { key: index }, [
                              _c("td", { staticClass: "td-num" }, [
                                _vm._v(_vm._s(index + 1))
                              ]),
                              _c(
                                "td",
                                { staticClass: "td-code" },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                      "error-messages":
                                        _setup.formState.errors[
                                          `units.${index}.unit_code`
                                        ]
                                    },
                                    model: {
                                      value: unit.unit_code,
                                      callback: function($$v) {
                                        _vm.$set(unit, "unit_code", $$v)
                                      },
                                      expression: "unit.unit_code"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "td-type" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                      items: _setup.UNIT_TYPES,
                                      "error-messages":
                                        _setup.formState.errors[
                                          `units.${index}.unit_type`
                                        ]
                                    },
                                    model: {
                                      value: unit.unit_type,
                                      callback: function($$v) {
                                        _vm.$set(unit, "unit_type", $$v)
                                      },
                                      expression: "unit.unit_type"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "td-lift" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                      items: _setup.LIFT_STATUSES,
                                      "error-messages":
                                        _setup.formState.errors[
                                          `units.${index}.lift_status`
                                        ]
                                    },
                                    model: {
                                      value: unit.lift_status,
                                      callback: function($$v) {
                                        _vm.$set(unit, "lift_status", $$v)
                                      },
                                      expression: "unit.lift_status"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "td-pm" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                      items: _setup.PM_STATUSES,
                                      clearable: "",
                                      "error-messages":
                                        _setup.formState.errors[
                                          `units.${index}.pm_status`
                                        ]
                                    },
                                    model: {
                                      value: unit.pm_status,
                                      callback: function($$v) {
                                        _vm.$set(unit, "pm_status", $$v)
                                      },
                                      expression: "unit.pm_status"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "td-text" },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                      "error-messages":
                                        _setup.formState.errors[
                                          `units.${index}.remarks`
                                        ]
                                    },
                                    model: {
                                      value: unit.remarks,
                                      callback: function($$v) {
                                        _vm.$set(unit, "remarks", $$v)
                                      },
                                      expression: "unit.remarks"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "td-text" },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                      "error-messages":
                                        _setup.formState.errors[
                                          `units.${index}.recommendations`
                                        ]
                                    },
                                    model: {
                                      value: unit.recommendations,
                                      callback: function($$v) {
                                        _vm.$set(unit, "recommendations", $$v)
                                      },
                                      expression: "unit.recommendations"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "td-action" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        color: "red",
                                        type: "button"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _setup.removeUnit(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-close")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          }),
                          0
                        )
                      ]),
                      _setup.formState.data.units.length === 0
                        ? _c("div", { staticClass: "units-empty" }, [
                            _vm._v(
                              ' No units yet. Click "Add Unit" or use Generate. '
                            )
                          ])
                        : _vm._e()
                    ])
                  ]
                : [
                    _vm._l(_setup.formState.data.units, function(unit, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "unit-row" },
                        [
                          _c(
                            "div",
                            { staticClass: "unit-row-header" },
                            [
                              _c("span", [_vm._v("Unit " + _vm._s(index + 1))]),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    color: "red",
                                    type: "button"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _setup.removeUnit(index)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-close")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "two-col" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  label: "Unit Code *",
                                  "error-messages":
                                    _setup.formState.errors[
                                      `units.${index}.unit_code`
                                    ]
                                },
                                model: {
                                  value: unit.unit_code,
                                  callback: function($$v) {
                                    _vm.$set(unit, "unit_code", $$v)
                                  },
                                  expression: "unit.unit_code"
                                }
                              }),
                              _c("v-select", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  label: "Unit Type *",
                                  items: _setup.UNIT_TYPES,
                                  "error-messages":
                                    _setup.formState.errors[
                                      `units.${index}.unit_type`
                                    ]
                                },
                                model: {
                                  value: unit.unit_type,
                                  callback: function($$v) {
                                    _vm.$set(unit, "unit_type", $$v)
                                  },
                                  expression: "unit.unit_type"
                                }
                              }),
                              _c("v-select", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  label: "Lift Status *",
                                  items: _setup.LIFT_STATUSES,
                                  "error-messages":
                                    _setup.formState.errors[
                                      `units.${index}.lift_status`
                                    ]
                                },
                                model: {
                                  value: unit.lift_status,
                                  callback: function($$v) {
                                    _vm.$set(unit, "lift_status", $$v)
                                  },
                                  expression: "unit.lift_status"
                                }
                              }),
                              _c("v-select", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  label: "PM Status",
                                  items: _setup.PM_STATUSES,
                                  clearable: "",
                                  "error-messages":
                                    _setup.formState.errors[
                                      `units.${index}.pm_status`
                                    ]
                                },
                                model: {
                                  value: unit.pm_status,
                                  callback: function($$v) {
                                    _vm.$set(unit, "pm_status", $$v)
                                  },
                                  expression: "unit.pm_status"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              label: "Remarks",
                              "error-messages":
                                _setup.formState.errors[
                                  `units.${index}.remarks`
                                ]
                            },
                            model: {
                              value: unit.remarks,
                              callback: function($$v) {
                                _vm.$set(unit, "remarks", $$v)
                              },
                              expression: "unit.remarks"
                            }
                          }),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              label: "Recommendations",
                              "error-messages":
                                _setup.formState.errors[
                                  `units.${index}.recommendations`
                                ]
                            },
                            model: {
                              value: unit.recommendations,
                              callback: function($$v) {
                                _vm.$set(unit, "recommendations", $$v)
                              },
                              expression: "unit.recommendations"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _setup.formState.data.units.length === 0
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#999",
                              "font-size": "13px",
                              "text-align": "center",
                              padding: "8px 0"
                            }
                          },
                          [
                            _vm._v(
                              ' No units added yet. Click "Add Unit" to add one. '
                            )
                          ]
                        )
                      : _vm._e()
                  ]
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "td-num" }, [_vm._v("#")]),
        _c("th", { staticClass: "td-code" }, [_vm._v("Unit Code")]),
        _c("th", { staticClass: "td-type" }, [_vm._v("Type")]),
        _c("th", { staticClass: "td-lift" }, [_vm._v("Lift Status")]),
        _c("th", { staticClass: "td-pm" }, [_vm._v("PM Status")]),
        _c("th", { staticClass: "td-text" }, [_vm._v("Remarks")]),
        _c("th", { staticClass: "td-text" }, [_vm._v("Recommendations")]),
        _c("th", { staticClass: "td-action" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }